module.exports = __webpack_public_path__ + "static/media/chevron-retour.e63f59dc.svg";